import React from "react";
import { PageNewState, ticketDetailPageInitialState } from ".";

export const TicketDetailPageContext = React.createContext({
  pageState: ticketDetailPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
